import React, { lazy, ReactElement, Suspense } from 'react';
import { MessageService } from '../../message-service';
import { useDispatch, useSelector } from 'react-redux';
import { updateMessages } from './modules/messages';
import { selectPersonalization, selectSocialFeeds, selectMeta, selectCustomFontPopup } from './modules/tint';
import { selectConfig } from './modules/config';
import usePopup from './hooks/use-popup';
import { clearPost } from './modules/posts';
import { globalConfig } from '../../shared/config/config';
import Font from '../../shared/components/font/font';
import StyleTag from '../../shared/components/style-tag/style-tag';
import { Nullable } from '../../shared/types/Typescript-utils';

const transitionDelayMs = 300;

const LazyLoadModalWrapper = lazy(() => import('./components/modal-wrapper/modal-wrapper'));

const App = (): Nullable<ReactElement> => {
  MessageService.send({
    type: globalConfig.postMessage.actions.popupLoaded,
  });
  usePopup();
  const dispatch = useDispatch();
  const personalization = useSelector(selectPersonalization);
  const socialFeeds = useSelector(selectSocialFeeds);
  const meta = useSelector(selectMeta);
  const config = useSelector(selectConfig);
  const customFontPopup = useSelector(selectCustomFontPopup);

  const close = () => {
    setTimeout(() => {
      MessageService.send({
        type: globalConfig.postMessage.actions.closePopup,
        tintSlug: config ? config.tintSlug : '',
      });
    }, transitionDelayMs);
    dispatch(updateMessages({ key: 'isMounted', value: false }));
    dispatch(clearPost());
  };

  if (personalization === null || socialFeeds === null || meta === null || config === null) {
    return null;
  }

  const popupFont = personalization?.attributes?.data?.popup_font;
  const popupFontUrl = personalization.attributes.data?.popup_font_woff_url;

  return (
    <>
      <Font
        fontConfig={{
          ...(popupFontUrl ? { fontUrl: popupFontUrl } : {}),
          ...(popupFont ? { fontFamily: popupFont } : {}),
          ...(customFontPopup ? { customFontCSS: customFontPopup } : {}),
        }}
      />
      <StyleTag customCSS={personalization.attributes.data.popup_custom_css} />
      <Suspense fallback={null}>
        <LazyLoadModalWrapper
          onClose={close}
          modalConfig={{
            personalization,
            socialFeeds,
            meta,
            config,
          }}
        />
      </Suspense>
    </>
  );
};

export default App;
